import { MAX_MOBILE_WIDTH } from '@/utils/constants';
import styled from 'styled-components';
import { roundnessCalculator } from '../../../../components/DesignSystem/AtomicComponents/util';
import store from '../../../../redux/store';

const storeInfo = store.getState().storeReducer.store;

export const CartCtaDesktopContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${roundnessCalculator(storeInfo?.theme?.roundness)};
  border: 1px solid ${storeInfo?.theme?.colors?.primary_color};
  padding-top: 12px;
  padding-bottom: 12px;
  width: ${props => props.cartCtaButtonWidth};
  cursor: pointer;
  color: ${storeInfo?.theme?.colors?.primary_color};
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}px) {
    font-size: 18px;
  }
`;

export const MobileOutOfStockContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 48px;
  justify-content: center;
  align-items: center;
  background: #c6c6c6;
  position: fixed;
  bottom: 0%;
  z-index: 3;
`;

export const MobileOutOfStockText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
`;
